module.exports = __webpack_public_path__ + "static/media/rocky-selector.89ce9500.png";